"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _pittaModules = require("@thingsw/pitta-modules");
var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useStyle = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: 40,
      height: 22,
      padding: 0,
      "&>.Mui-disabled": {
        color: _pittaModules.LightColors.primary["0"],
        "&$checked": {
          "& + $track": {
            opacity: 0.35
          }
        },
        "& + $track": {
          backgroundColor: _pittaModules.LightColors.primary["4"],
          opacity: 0.35
        }
      }
    },
    switchBase: {
      width: 18,
      height: 18,
      padding: 0,
      margin: 2,
      color: "".concat(_pittaModules.LightColors.primary["0"], "!important"),
      "&$checked": {
        margin: "2px 2px 2px 0px",
        color: _pittaModules.LightColors.primary["0"],
        "& + $track": {
          backgroundColor: _pittaModules.LightColors.primary["7"],
          opacity: 1
        }
      }
    },
    thumb: {
      width: 18,
      height: 18,
      boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.14), \n                 0px 1px 1px rgba(0, 0, 0, 0.12), \n                 0px 0px 3px rgba(0, 0, 0, 0.2)"
    },
    track: {
      borderRadius: 11,
      backgroundColor: _pittaModules.LightColors.primary["4"],
      opacity: 1
    },
    checked: {}
  };
});
var Switch = function Switch(props) {
  var classes = useStyle(props);
  var checked = props.checked,
    disabled = props.disabled,
    onChange = props.onChange;
  return /*#__PURE__*/_react.default.createElement(_Switch.default, {
    disableRipple: true,
    classes: {
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked
    },
    checked: checked,
    disabled: disabled,
    inputProps: {
      role: "switch"
    },
    onChange: onChange
  });
};
exports.Switch = Switch;